import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import {
  init,
  reactRouterV7BrowserTracingIntegration,
  replayIntegration,
} from '@sentry/react';

export default class Sentry {
  private static readonly maxResponseSize = 50 * 1024; // 50KB in bytes

  static configure() {
    init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      sendDefaultPii: true,
      integrations: [
        reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
          networkCaptureBodies: true,
          networkDetailAllowUrls: ['cognito-idp', 'cognito-identity'],
        }),
      ],
      tracePropagationTargets: ['cognito-idp', 'cognito-identity'],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeBreadcrumb: (breadcrumb, hint) => {
        let additionalData: Record<string, string> = {};

        if (breadcrumb.category === 'xhr') {
          const xhr = hint?.xhr as XMLHttpRequest;
          let { responseText } = xhr;

          if (responseText.length > this.maxResponseSize) {
            responseText = `${responseText.substring(0, this.maxResponseSize)}... [truncated]`;
          }

          additionalData = {
            response_text: responseText,
          };
        }

        return {
          ...breadcrumb,
          data: {
            ...breadcrumb.data,
            ...additionalData,
          },
        };
      },
    });
  }
}
